import * as types from '../constants/actionTypes';
const initialState = {
	specialistList: [],
	patientList: []
};

export default function timer(state = initialState, action) {
	switch (action.type) {
		case types.GET_ALL_SPECIALISTS:
			return {
				...state,
				specialistList: action.specialistList
			};
		case types.GET_ALL_PATIENTS:
			return {
				...state,
				patientList: action.patientList
			};
		default:
			return state;
	}
}
